module.exports = __webpack_public_path__ + "static/media/21.91266116.png";